import { TLink } from "../../../types/link-types";
import { Link as GatsbyLink } from "gatsby-link";
import { cleanUrl, isOrHandleAsExternalUrl } from "../../../helpers";

type TLinkForCurrentPage = {
  onClick?: () => void;
  title?: string;
  className?: string;
  children?: React.ReactNode;
};

const LinkForCurrentPage = ({ onClick, title, className, children }: TLinkForCurrentPage) => {
  return (
    <span role="button" onClick={onClick} className={className}>
      {children ? children : title}
    </span>
  );
};

type TLinkProps = Partial<TLink> & {
  className?: string;
  children?: React.ReactNode;
  onClickCurrentPageLink?: () => void;
  currentPageUrl?: string;
  iconLeft?: string;
  iconRight?: string;
};

const Link = ({
  title,
  url,
  className,
  target,
  ariaLabel,
  rel,
  children,
  currentPageUrl,
  onClickCurrentPageLink,
  iconLeft,
  iconRight,
}: TLinkProps) => {
  if (!url) {
    return (
      <span className={className}>
        {iconLeft && <span className={iconLeft} />}
        {children && children}
        {!children && title}
        {iconRight && <span className={iconRight} />}
      </span>
    );
  }

  url = cleanUrl(url);

  if (currentPageUrl && currentPageUrl === url) {
    return (
      <LinkForCurrentPage
        className={className}
        onClick={onClickCurrentPageLink ? onClickCurrentPageLink : undefined}
        title={title}
      >
        {iconLeft && <span className={iconLeft} />}
        {children && children}
        {!children && title}
        {iconRight && <span className={iconRight} />}
      </LinkForCurrentPage>
    );
  }

  if (isOrHandleAsExternalUrl(url, target)) {
    return (
      <a aria-label={ariaLabel} href={url} target={target} className={className} rel={rel}>
        {iconLeft && <span className={iconLeft} />}
        {children && children}
        {!children && title}
        {iconRight && <span className={iconRight} />}
      </a>
    );
  }

  return (
    <GatsbyLink aria-label={ariaLabel} className={className} to={url} rel={rel}>
      {iconLeft && <span className={iconLeft} />}
      {children && children}
      {!children && title}
      {iconRight && <span className={iconRight} />}
    </GatsbyLink>
  );
};

export default Link;
